'use client';
import React from 'react';
import { Epg, Layout, useEpg, Theme } from 'planby';
import { ChannelItem } from './ChannelItem';
import styles from './tvguide-mock.module.sass';
import { channels } from './mock/channels';
import { epg } from './mock/epg';
import { ProgramCard } from './ProgramCard';
import { TimeLine } from './TimeLine';

// Temporrary hack to set always a current day
const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1); // Move to next day

const modifiedPrograms = epg.map((program) => {
    const programSince = new Date(program.since);
    const programTill = new Date(program.till);

    // Determine base date (today or tomorrow)
    const baseDate = program.isTomorrow ? tomorrow : today;

    // Preserve original time but update only the date
    const newSince = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        baseDate.getDate(),
        programSince.getHours(),
        programSince.getMinutes(),
        programSince.getSeconds()
    );

    const newTill = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        baseDate.getDate(),
        programTill.getHours(),
        programTill.getMinutes(),
        programTill.getSeconds()
    );

    return {
        ...program,
        since: newSince.toISOString(),
        till: newTill.toISOString(),
    };
});

// custom theme
const customTheme: Theme = {
    primary: {
        600: 'var(--white-10)',
        900: 'var(--primary-colors-background)',
    },
    grey: { 300: '#d1d1d1' },
    white: '#fff',
    green: {
        300: 'var(--primary-colors-orange)',
    },
    loader: {
        teal: '#5DDADB',
        purple: '#3437A2',
        pink: '#F78EB6',
        bg: '#171923db',
    },
    scrollbar: {
        border: 'var(--primary-colors-background)',
        thumb: {
            bg: 'var(--primary-colors-background)',
        },
    },
    gradient: {
        blue: {
            300: '#fff',
            600: '#fff',
            900: '#fff',
        },
    },
    text: {
        grey: {
            300: '#a0aec0',
            500: '#718096',
        },
    },
    timeline: {
        divider: {
            bg: '#718096',
        },
    },
};

const indexedChannels = channels.map((channel, index) => ({
    ...channel,
    index, // Add index manually
}));

export const EPG = ({ onProgramSelect }) => {
    const { getEpgProps, getLayoutProps } = useEpg({
        channels: indexedChannels,
        epg: modifiedPrograms,
        sidebarWidth: 104,
        itemHeight: 102,
        theme: customTheme,
        isLine: false,
        isTimeline: false,
    });

    return (
        <div className={styles.epgContainer}>
            <Epg {...getEpgProps()}>
                <Layout
                    {...getLayoutProps()}
                    // renderTimeline={(props) => <TimeLine {...props} />}
                    renderChannel={({ channel }) => (
                        <ChannelItem key={channel.uuid} channel={channel} index={channel.index} />
                    )}
                    renderProgram={({ program }) => (
                        <ProgramCard key={program.data.id} program={program} isRTL={false} isBaseTimeFormat={false} />
                    )}
                />
            </Epg>
        </div>
    );
};
